import { BrowserRouter, Routes, Route } from "react-router-dom";
import SigninCallback from "../auth/AuthCallback";
import SigninStart from "../auth/SignInStart";
import TabConfig from "./TabConfig";
import Tab from "./Tab";
import { AuthWrapper } from "../auth/AuthWrapper";
import Action from "./Action";
import TicketForm from "./TicketForm";
import SilentCallback from "../auth/SilentCallback";
import SilentStart from "../auth/SilentStart";
import SilentEnd from "../auth/SilentEnd";

export default function AppRoutes() {

    return (<>
        <BrowserRouter >
            <Routes >
                <Route path="/silent-start" element={<SilentStart />} />
                <Route path="/silent-end" element={<SilentEnd />} />
                <Route path="/signin-callback" element={<SigninCallback />} />
                <Route path="/silent-callback" element={<SilentCallback />} />
                <Route path="/signin-start" element={<SigninStart />} />
                {/* secure routes */}
                <Route path="/config" element={<AuthWrapper>
                    <TabConfig />
                </AuthWrapper>} />
                <Route path="/tabconfig" element={<AuthWrapper>
                    <TabConfig />
                </AuthWrapper>} />
                <Route path="/log" element={<AuthWrapper>
                    <TicketForm />
                </AuthWrapper>} />
                <Route path="/action" element={<AuthWrapper>
                    <Action />
                </AuthWrapper>} />
                <Route path="*" element={<AuthWrapper>
                    <Tab />
                </AuthWrapper>}></Route>

            </Routes>
        </BrowserRouter>
    </>
    );
}